export const InitialReserve = {
    firstname: '',
    lastname: '',
    telnum: '',
    email: '',
    message: ''
}